<script lang="ts">
  import SearchBar from "$lib/components/side-bar.svelte";
  import Map from "$lib/components/map/map.svelte";
  import InstallDialog from "$lib/components/install-dialog.svelte";

  let popupElement: HTMLDivElement;
  let firstLoadFinish = $state(false);
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link
    rel="preconnect"
    href="https://fonts.gstatic.com"
    crossorigin="anonymous"
  />
  <link
    href="https://fonts.googleapis.com/css2?family=Lalezar&family=Open+Sans:wght@300;400;600;700&display=swap"
    rel="stylesheet"
  />
</svelte:head>

<div class="relative w-full h-screen overflow-hidden bg-background">
  <Map bind:popupElement bind:firstLoadFinish />
  {#if firstLoadFinish}
    <SearchBar />
  {/if}
</div>

<InstallDialog />
<!-- Beeco watermark -->
<img
  class="absolute bottom-0 left-0"
  src="/assets/beeco-watermark.svg"
  alt="beeco"
/>

<style>
  :global(.font-display) {
    font-family: "Lalezar", sans-serif;
  }

  :global(#map) {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
  }
</style>
